<template>
  <div class="print">
    <!-- head -->
    <div class="print-head">
      <div class="flex" style="position: relative; align-items: center;">
        <img src="@/assets/images/동국제강_로그인.svg" style="margin-right: auto;" />
        <h1 style="position: absolute; left: 50%; transform: translateX(-50%);">RPA(환경 데이터)</h1>
      </div>
    </div>

<!--    결재선-->
    <div v-if="결재라인 && 결재라인.length > 0">
      <div class="section-title">결재선</div>
      <table>
        <thead>
        <tr>
          <th>구분</th>
          <th>상태</th>
          <th>부서</th>
          <th>이름</th>
          <th>결재일시</th>
          <th>의견(반려)</th>
        </tr>
        <tr v-for="결재 in 결재선">
          <td>{{ 결재.type_name === '상신'? '기안' : 결재.type_name }}</td>
          <td>{{ 결재.status_name }}</td>
          <td>{{ 결재.company_name }}</td>
          <td>{{ 결재.user_name }}</td>
          <td>{{ 결재.updated_at }}</td>
          <td>
            <div v-if="결재.comments.length > 0">
              <div v-for="comment in 결재.comments">
                <span>{{ comment.comment }}</span>
              </div>
            </div>
            <span v-else>-</span>
          </td>
        </tr>
        </thead>
      </table>

      <div class="section-title bottom-line pb-2 mt-28px">수신참조</div>
      <div v-if="결재라인Map['reference']">{{ 결재라인Map['reference'].company_name }} {{결재라인Map['reference'].user_name }}</div>

      <div class="section-title bottom-line pb-2 mt-28px">회람자</div>
      <div v-if="결재라인Map['circulation']">{{ 결재라인Map['circulation'].company_name }} {{결재라인Map['circulation'].user_name }}</div>

      <table class="mt-28px">
        <tr v-if="결재라인Map['register']">
          <th>기안일</th>
          <td>{{ 결재라인Map['register'].updated_at }}</td>
          <th>기안자</th>
          <td>{{ 결재라인Map['register'].user_name }}</td>
        </tr>
      </table>
    </div>

<!--    본문 테두리 -->
    <div class="mt-4 inline-border">
      <div class="section-title">점검정보</div>
      <table>
        <tr>
          <th>사업장명</th>
          <td>{{ form.stdInfo.field_name}}</td>
          <th>점검종류</th>
          <td>
            <div class="flex gap-4">
              <PrintRadio :value="form.점검종류 === '정기'" class="justify-center" label="정기"/>
              <PrintRadio :value="form.점검종류 === '수시'" class="justify-center" label="수시"/>
            </div>
          </td>
        </tr>
        <tr>
          <th>점검일</th>
          <td>{{ form.점검일 }}</td>
          <th>점검기관</th>
          <td>{{ form.점검기관.join(', ') }}</td>
        </tr>
      </table>

      <div class="section-title">점검대상</div>
      <div class="mt-4 inline-border">
        <div class="grid grid-cols-6 gap-4">
          <div v-for="target in form.점검대상">
            <div class="flex items-center">
              <PrintCheckbox :label="target.name" :value="target.check"  />
            </div>
          </div>
        </div>
      </div>

      <div class="section-title">점검내용</div>
      <table>
        <tr>
          <th>시료채취 유무</th>
          <td>
            <div class="flex gap-4">
              <PrintRadio :value="form.시료채취유무 === '유'" class="justify-center" label="O"/>
              <PrintRadio :value="form.시료채취유무 === '무'" class="justify-center" label="X"/>
            </div>
          </td>
        </tr>
        <tr>
          <th>점검내용</th>
          <td>{{ form.점검내용 }}</td>
        </tr>
        <tr>
          <th>시료채취사항</th>
          <td>{{ form.시료채취사항 }}</td>
        </tr>
        <tr>
          <th>점검자</th>
          <td>{{ form.점검자 }}</td>
        </tr>
      </table>

      <div class="section-title">점검결과</div>
      <table>
        <colgroup>
          <col width="140" />
          <col />
        </colgroup>
        <tr>
          <td colspan="2" style="padding: 10px 20px;">
            <div v-for="target in form.점검결과">
              <div class="grid mt-2" style="grid-template-columns: 100px 1fr">
                <PrintCheckbox :label="target.type" :value="target.check"  />
                <span v-if="target.check">세부사항: {{ target.세부사항 }}</span>
              </div>
            </div>
          </td>
        </tr>
        <tr v-for="(item, itemIndex) in 점검결과사항Array" :key="`${item.name}_${itemIndex}`">
          <th>{{ item.name }}</th>
          <td>{{ form.점검결과사항[item.name] }}</td>
        </tr>
      </table>

      <div class="section-title">첨부파일</div>
      <table>
        <tr v-for="file in form.fileList">
          <td class="py-1 px-2">
            <div class="flex">
              <span>{{ file.fileName }}</span>
              <span style="margin-left: 10px; font-size: 12px; color: #9CA0A4">({{file.fileSize}} bytes)</span>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>

import PrintRadio from "@/components/print/PrintRadio.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

export default {
  name: "Print",
  components: {PrintCheckbox, PrintRadio},
  props: {
    form: Object,
    board: Object,
  },
  data() {
    return {
      chart: [],
    };
  },
  computed: {
    결재라인() {
      return this.board.approvalLine;
    },
    결재선() {
      return this.결재라인.filter(item => item.type_code !== 'reference' && item.type_code !== 'circulation');
    },
    결재라인Map() {
      return this.결재라인.reduce((map, item) => {
        map[item.type_code] = item;
        return map;
      }, {});
    },
    점검결과사항Array() {
      return Object.keys(this.form.점검결과사항).map(key => {
        return { name: key, value: this.form.점검결과사항[key] };
      });
    },
  },
  created() {
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.print-head {
  padding-bottom: 1rem;

  h1 {
    font-weight: bold;
    text-align: center;
    padding: 20px 0 14px;
  }
  .stdInfo {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 1rem;
    margin-top: 20px;
    div {
      display: grid;
      grid-template-columns: 114px 1fr;
      align-items: center;
      span {
        margin-right: 10px;
      }
    }
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th, td {
    border: solid 1px #cdcdcd;
  }

  th {
    padding: 4px 0;
    width: 140px;
    background-color: #ECECEC;
    text-align: center;
  }

  td {
    padding: 0 7px;
  }

  thead {
    td {
      text-align: center
    }
  }
  tbody {
    td {
      text-align: start;
    }
  }
}

.bottom-line {
  padding-bottom: 1rem;
  border-bottom: 1px solid #cdcdcd;
}

.section-title {
  font-size: 16px;
  font-weight: 500;
  margin-top: 20px;
  margin-bottom: 10px
}

.inline-border {
  width: 100%;
  border-collapse: collapse;
  border: solid 1px #cdcdcd;
  padding: 20px;
}
</style>
